import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  BussinessHomeCardData,
  ColorThemeInterface,
  TextCartItemType,
  BusinessDetailsType,
  SubscriptionType,
} from "../pages/BussinessHomePage";
import { useAppSelector, useModalController } from "../app/hooks";
import { mobileWidthBreakpoint } from "../types/form_table_data_types";
import ImageArraySlider from "../UI/ImageArraySlider";
import VariantPricing, {
  VariantPriceDisplay,
  VariantPricingSelModal,
} from "./VariantPricing";
import { IonIcon, IonFooter } from "@ionic/react";
import {
  IonButtons,
  IonButton,
  IonModal,
  IonHeader,
  IonContent,
  IonToolbar,
  IonTitle,
} from "@ionic/react";

import { add, business, chevronForward, close } from "ionicons/icons";

import {
  getSeoUrl,
  isFullyQualifiedUrl,
  searchStringSuccess,
} from "../common/commonFunctions";
import ContentWithBackground from "../UI/ContentWithBackground";
import finalPropsSelectorFactory from "react-redux/es/connect/selectorFactory";
import {
  API_SECURE_KEY,
  getFileThumbnailDB,
  IDIGIZEN_BACKEND_URL,
} from "../types/constants";
import { getSessionDetails } from "../common/cookies";
import { AdvanceCustomizationType, CartItemTypes } from "../types/data_types";

const BussinessHomeCard: React.FC<{
  darkMode?: boolean;
  businessDetails?: BusinessDetailsType;
  subscriptionType?: SubscriptionType;
  openCart?: Function;
  disableSnipping?: boolean;
  imgDivId?: string;
  imgDivIdPostFix?: string;
  urlParams?: string;
  isMultiProd?: boolean;
  searchText?: string;
  marketListing: boolean;
  openCloseCard?: Function;
  theme: ColorThemeInterface;
  data: BussinessHomeCardData;
  cartItems: CartItemTypes[];
  textCartItems: TextCartItemType[];
  cat?: string;
  id?: number | string;
  variantIdCallBack: Function;
  addRemoveCartCallBack: Function;
  fullHeight: boolean;
  selected?: boolean;
  isSpecial?: boolean;
  openExpandImg: (filename: string[], index: number) => void;
  openDetails?: (id: number | string) => void;
  isMarket: boolean;
  parentDomain: string;
  // openPromo?: () => void;
  addOrderItemized?: (name: string) => void;
  addItemizedFromText?: (
    name: string,
    hasEntry: boolean,
    cardData: BussinessHomeCardData
  ) => void;
  listModeListing?: boolean | number;
  buttonOverride?: {
    icon?: any;
    name?: string;
    onClick?: (id: string | number) => void;
    businessDetails?: BusinessDetailsType;
  };
  marketShowPrice?: boolean;
  cardShadowMode?: boolean;
  nameCardMode?: boolean;
  onClickCallback?: () => void;
  advanceCustomization: AdvanceCustomizationType;
}> = (props) => {
  let screenType: "PC" | "Tab" | "Mobile" = "PC";
  const widthObj: { width: number } = useAppSelector((state) => {
    return state.screenWidth;
  });

  //console.log("props.data =", props.data);

  if (widthObj.width > 1100) screenType = "PC";
  else if (widthObj.width > 600) screenType = "Tab";
  else screenType = "Mobile";

  const textBoxRef = useRef(null);
  const [imgLoadRefresh, setImgLoadRefresh] = useState(false);
  const imageBoxId = !props.imgDivId
    ? `bhp-image-box-card-${props.id}${props.isSpecial ? "-special" : ""}${
        props.imgDivIdPostFix ? `-${props.imgDivIdPostFix}` : ""
      }`
    : props.imgDivId;

  // const adjustHeight = (calling: string = "useEffect") => {
  //   const divImgEl = document.getElementById(imageBoxId) as HTMLElement;
  //   if (divImgEl) {
  //     if (!divImgEl.offsetWidth) {
  //       setImgLoadRefresh((val) => !val);
  //     }
  //     divImgEl.style.height = `${divImgEl.offsetWidth * 0.75}px`;
  //   }
  // };
  // useEffect(() => {
  //   setTimeout(adjustHeight.bind(this, `use-500-${imgLoadRefresh}`), 500);
  // }, [widthObj, props.data.imagePath, imgLoadRefresh, props.data?.imageData]);

  const outerDivRef = useRef(null);

  const expandFunc = (index) => {
    // props.openExpandImg(props.data.imagePath, index);
    // console.log("mapping", props.data.imagePath);
  };
  const [selectedcVariantIndex, setSelectedVariantIndex] = useState(0);

  // const cartItem = props.cartItems?.find((ci) => {
  //   if (ci.variantName) {
  //     return (
  //       ci.id === props.id &&
  //       ci.variantName === props.data.variant[selectedcVariantIndex].option
  //     );
  //   } else {
  //     return ci.id === props.id;
  //   }
  // });
  // const cartItemTotalCount = props.cartItems?.filter((ci) => {
  //   return ci.id === props.id;
  // });
  // const totalCount = cartItemTotalCount?.reduce(
  //   (sum, obj) => sum + obj.count,
  //   0
  // );

  const cardCharLimit = props.disableSnipping ? 10000000 : 100;
  const [textLimLeft, setTextLimLeft] = useState(0);

  const isMobile =
    useAppSelector((state) => state.screenWidth).width < mobileWidthBreakpoint;

  const [productArray, setProductArray] = useState<
    { val: string; show: boolean; selected: boolean }[]
  >([]);

  useEffect(() => {
    if (props.data?.productList) {
      const retVal: {
        val: string;
        show: boolean;
        selected: boolean;
      }[] = [];
      const frags = props.data.productList.split(",").filter(Boolean);
      console.log("Text in ", props.data.text, " array ", retVal);
      let length = 0;
      let limitExp = false;

      for (const frag of frags) {
        if (!searchStringSuccess(props.searchText, frag)) continue;
        length = length + frag.length;
        const fragRet: { val: string; show: boolean; selected: boolean } = {
          val: frag,
          show: true,
          selected: props.textCartItems.find(
            (el) => el.name === `${props.data.title} - ${frag}`
          )
            ? true
            : false,
        };
        retVal.push(fragRet);
        if (length > cardCharLimit) {
          fragRet.show = false;
          limitExp = true;
        }

        // lengthSoFar = lengthSoFar + frag.val.length;
      }
      if (limitExp) {
        setTextLimLeft(0);
      } else {
        setTextLimLeft(cardCharLimit - length);
      }
      setProductArray(retVal);
    } else {
      setProductArray([]);
      setTextLimLeft(cardCharLimit);
    }
  }, [props.data.productList, props.textCartItems]);

  //   const [expanded, setExpanded] = useState(false);

  //   const toggleExpanded = (id, title, text, imagePath) => {
  //     console.log("gdata : ", id, title, text, imagePath);

  //     props.openCloseCard(id, title, text, imagePath);
  //   };
  const highlightText = (text: string) => {
    if (!props.searchText) {
      return text;
    }

    const regex = new RegExp(props.searchText, "gi");
    return text?.replace(
      regex,
      (match) => `<span style="background-color: yellow;">${match}</span>`
    );
  };

  const modal = useRef<HTMLIonModalElement>(null);
  const page = useRef(null);

  const [presentingElement, setPresentingElement] =
    useState<HTMLElement | null>(null);

  useEffect(() => {
    setPresentingElement(page.current);
  }, []);

  function dismiss() {
    modal.current?.dismiss();
  }

  async function canDismiss(data?: any, role?: string) {
    return role !== "gesture";
  }

  const [isOpen, setIsOpen] = useState(false);
  const [openVarientSel, closeVarientSel] = useModalController(
    "varSel",
    setIsOpen,
    () => {
      setIsOpen(false);
    }
  );

  const handleOpenVarientModel = () => {
    // openVarientSel(true);
    setIsOpen(true);
  };

  const variantModalJsx = (
    <VariantPricingSelModal
      entityId={props.businessDetails.id}
      addRemoveCartCallBack={props.addRemoveCartCallBack}
      cartItems={props.cartItems}
      data={props.data}
      disablePriceDisplay={
        props.subscriptionType === "CATALOGUE" && props.listModeListing
          ? true
          : false
      }
      isMarket={props.isMarket}
      isOpen={isOpen}
      onDismiss={() => {
        setIsOpen(false);
        // closeVarientSel();
      }}
      subscriptionType={props.subscriptionType}
      OpenVarientModel={handleOpenVarientModel}
      addOrderItemized={props.addOrderItemized}
      buttonOverride={props.buttonOverride}
      id={props.id}
      marketShowPrice={props.marketShowPrice}
      advanceCustomization={props.advanceCustomization}
    />
  );

  const businessCardHorizontalJsx = (
    <div
      className="stakeholder-card-horizontal-top"
      style={{
        position: "relative",
        height: props.fullHeight ? "100%" : undefined,
      }}
      onClick={() => {
        if (!!props?.nameCardMode) {
          if (isFullyQualifiedUrl(props.data?.domain)) {
            window.location.assign(props.data?.domain);
          } else {
            window.location.assign(getSeoUrl(props.data.seoUrlDetails));
          }
        }
      }}
    >
      {!!props?.nameCardMode && (
        <img
          style={{
            boxShadow: props.darkMode
              ? "0 3px 6px rgba(255,255,255,0.9)"
              : "0 3px 6px rgba(0,0,0,0.2)",
            height: "45px",
            width: "45px",
            objectFit: "cover",
            overflow: "hidden",
            border: "2px solid var(--ion-color-medium)",
            borderRadius: "50%",
            flexShrink: 0,
            marginRight: "10px",
          }}
          src={
            props.data?.imagePath?.length
              ? `${IDIGIZEN_BACKEND_URL}/${getFileThumbnailDB}?fileName=${
                  props.data.imagePath[0]
                }&percentage=30&token=${
                  getSessionDetails().token
                }&Authorization=${API_SECURE_KEY}&`
              : "assets/profile.avif"
          }
          alt=""
        />
      )}
      <div style={{ flexGrow: 1, paddingRight: "10px" }}>
        <div className="stakeholder-horizontal-title">{props.data.title}</div>
        {!!props.data.text && (
          <div
            style={{
              fontSize: "0.8rem",
              color: "var(--ion-color-medium)",
              paddingBottom: "5px",
            }}
          >
            {props.data.text}
          </div>
        )}
        <VariantPriceDisplay
          subscriptionType={props.subscriptionType}
          price={props.data.variant?.length ? props.data.variant[0]?.price : 0}
          listPrice={
            props.data.variant?.length ? props.data.variant[0]?.listPrice : 0
          }
          unit={props.data.variant?.length ? props.data.variant[0]?.unit : 0}
          // discountJsx={discountJsx}
          // hasDiscount={hasDiscount}
          listModeListing={props.listModeListing}
          bhpEditLinks={props.businessDetails?.bhpEditLinks}
          showUnitListMode={
            props.businessDetails.isMarket &&
            props.businessDetails.marketType === "RWA" &&
            props.businessDetails.subType === "BNI-CHAPTER"
          }
          unitStringOverride={
            props.businessDetails.isMarket &&
            props.businessDetails.marketType === "RWA" &&
            props.businessDetails.subType === "BNI-CHAPTER"
              ? "From"
              : ""
          }
          advanceCustomization={props.advanceCustomization}
        />
      </div>
      <div className="stakeholder-horizontal-price-wrpr">
        {!props?.nameCardMode && (
          <VariantPricing
            entityId={props.businessDetails.id}
            listModeListing={props.listModeListing}
            subscriptionType={props.subscriptionType}
            isVarientMode={false}
            data={props.data}
            index={0}
            cartItems={props.cartItems}
            addOrderItemized={props.addOrderItemized}
            isMarket={props.isMarket}
            id={props.id}
            addRemoveCartCallBack={props.addRemoveCartCallBack}
            OpenVarientModel={handleOpenVarientModel}
            openCart={props.openCart}
            buttonOverride={props.buttonOverride}
            marketShowPrice={props.marketShowPrice}
            bhpEditLinks={props.businessDetails.bhpEditLinks}
            advanceCustomization={props.advanceCustomization}
          />
        )}
        {!!props?.nameCardMode && (
          <IonButton color={"medium"} fill="clear" size="small">
            <IonIcon icon={chevronForward} />
          </IonButton>
        )}
      </div>
    </div>
  );

  const numCards = isMobile ? 2 : 4;
  const cardImgHeightPx = `${
    ((window.innerWidth - (2 + numCards * 2) * 5) / numCards) * 0.75
  }px`;

  // const hasPrice = useMemo(() => {
  //   const data = props.data?.variant?.length
  //     ? props.data.variant[0]
  //     : undefined;
  //   if (!data || !data.price) return false;
  //   else return true;
  // }, [props.data]);

  const businessCardVerticalJsx = (
    <>
      <a
        href={
          isFullyQualifiedUrl(props.data.domain)
            ? props.data.domain
            : getSeoUrl(props.data.seoUrlDetails)
        }
        className="bhp-a-tag-no-style"
        style={{ height: "100%" }}
      >
        <div
          className={`stakeholder-card-top-vertical ${
            props.selected ? "stakeholder-card-top-highlighted" : ""
          }`}
          id={`business-home-page-market-domain-${props.data?.domain}`}
          style={{
            border: props.cardShadowMode ? "1px solid #dadce0" : undefined,
            backgroundColor: props.data?.isNotListed
              ? "rgba(var(--ion-color-danger-rgb),.3)"
              : !props?.cardShadowMode
              ? undefined
              : props.selected
              ? props.theme.selectedCardColor
              : props.isSpecial
              ? props.theme.specialCardColor
              : props.theme.defaultCardColor,
            color: props.isSpecial
              ? props.theme.specialCardTextColor
              : props?.darkMode
              ? "var(--ion-color-light)"
              : props.theme.defaultCardtextColor,
            boxShadow: !props.cardShadowMode
              ? undefined
              : props.isSpecial
              ? "0 3px 6px #b69a07"
              : "0 3px 6px rgba(0,0,0,0.2)",
            height: props.fullHeight ? "100%" : undefined,
          }}
          onClick={(e) => {
            if (props.onClickCallback) props.onClickCallback();
            // if (props.parentDomain === "demoshop") {
            // if (props.openPromo) props.openPromo();
            // return;
            // }
            if (props.marketListing) {
              e.stopPropagation();
              window.location.assign(getSeoUrl(props.data.seoUrlDetails));
              // window.location.assign(`https://${props.data.domain}.vypzee.com`);
              return;
              // history.push(`/business/${props.data.domain}`);
            }
            if (!props.data.domain || props.data?.subscriptionType === "NONE") {
              if (props.openDetails) props.openDetails(props.data.id);
              return;
            }
            e.stopPropagation();
            if (isFullyQualifiedUrl(props.data.domain)) {
              window.location.assign(props.data.domain);
              return;
            }
            let url = getSeoUrl(props.data.seoUrlDetails);
            url += props.urlParams ? props.urlParams : "";
            window.location.assign(url);
            // history.push(`/business/${props.data.domain}`);
          }}
        >
          {props.isMarket &&
            props.data.advertising &&
            !!props.data.advertising.filter(
              (el) =>
                el.category === "Sales/ Promotions" &&
                el.shopDomain === props.data.domain
            ).length && (
              <div className="ribbon-wrapper-green">
                <div className="ribbon-green">
                  Offers (
                  {
                    props.data.advertising.filter(
                      (el) => el.category === "Sales/ Promotions"
                    ).length
                  }
                  )
                </div>
              </div>
            )}
          {!props.isMarket && !props.isSpecial && props.data.isSpecial && (
            <div className="ribbon-wrapper-green">
              <div className="ribbon-green">Featured</div>
            </div>
          )}

          <div className="card_vertical_div_dection">
            {!!props.data.imagePath?.length && (
              <div
                ref={outerDivRef}
                id={imageBoxId}
                className="product_card-left"
                style={{
                  backgroundColor: props.isSpecial
                    ? props.theme.prodImgBgSpecialColor
                    : props.theme.prodImgBgDefaultColor,
                  height: cardImgHeightPx,
                  boxShadow: !props.cardShadowMode
                    ? props?.darkMode
                      ? "0 3px 6px rgba(255,255,255,0.3)"
                      : "0 3px 6px rgba(0,0,0,0.2)"
                    : undefined,
                }}
              >
                {/* <img src={imageUrls[0]} className="stakeholder-card-img" /> */}
                <ImageArraySlider
                  objectFit="cover"
                  disableScroll={true}
                  disableShifter={props.isMarket}
                  imageJsonArray={props.data.imagePath}
                  onClick={expandFunc}
                  disableClick={props.isMarket}
                />
              </div>
            )}
            <div className="product_card-right">
              <div
                className="product_card-right-top"
                ref={textBoxRef}
                style={{
                  padding: props.cardShadowMode ? "7px" : "10px 0 10px 0",
                }}
              >
                <div
                  className="product-card-right-title"
                  style={{
                    color: props?.darkMode
                      ? "var(--ion-color-light)"
                      : undefined,
                  }}
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: highlightText(props.data.title),
                    }}
                  />
                  {/* {!!props.data.domain && (
                  <div className="bhp-enter-shop-button">Order Now!</div>
                )} */}
                </div>
                {props.data.subtitle && (
                  <div
                    style={{
                      marginTop: "3px",
                      fontSize: ".7rem",
                      color: "var(--ion-color-medium)",
                    }}
                  >
                    {props.data.subtitle}
                  </div>
                )}
                <div
                  className="product_card-right-top-text"
                  style={{
                    color: props?.darkMode ? "lightgray" : undefined,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      width: "100%",
                    }}
                  >
                    {productArray.map((el, idx) => {
                      return (
                        <div
                          key={idx}
                          className={`bhp-card-product-add-button ${
                            el.selected ? "bhp-card-product-add-button-sel" : ""
                          }`}
                          onClick={() => {
                            props?.addItemizedFromText(
                              el.val,
                              el.selected,
                              props.data
                            );
                          }}
                        >
                          <div
                            style={{
                              marginRight: "2px",
                              maxWidth: "100%",
                              overflow: "scroll",
                            }}
                            dangerouslySetInnerHTML={{
                              __html: highlightText(el.val),
                            }}
                          />
                          <IonIcon icon={add} />
                        </div>
                      );
                    })}
                  </div>
                  {!!props.data?.text?.length && (
                    <>
                      <div style={{ cursor: "pointer" }}>
                        {!!props.data.text && !!textLimLeft && (
                          <>
                            <div
                              style={{
                                width: "100%",
                              }}
                            >
                              <div
                                style={{ width: "100%" }}
                                dangerouslySetInnerHTML={{
                                  __html: highlightText(
                                    props.data.text.slice(0, textLimLeft)
                                  ),
                                }}
                              />
                              {props.data.text.length > textLimLeft && (
                                <span
                                  style={{
                                    color: props?.darkMode
                                      ? "var(--ion-color-medium)"
                                      : "var(--ion-color-hyperlink)",
                                  }}
                                  // onClick={(e) => {
                                  //   e.stopPropagation(); // This stops the event from propagating to the parent
                                  //   props.openCloseCard(
                                  //     props.id,
                                  //     props.data.title,
                                  //     props.data.text,
                                  //     props.data.imagePath
                                  //   );
                                  // }}
                                >
                                  ...See More
                                </span>
                              )}
                            </div>
                          </>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
          <VariantPricing
            entityId={props.businessDetails.id}
            subscriptionType={props.subscriptionType}
            isVarientMode={false}
            data={props.data}
            index={0}
            cartItems={props.cartItems}
            addOrderItemized={props.addOrderItemized}
            isMarket={props.isMarket}
            id={props.id}
            addRemoveCartCallBack={props.addRemoveCartCallBack}
            OpenVarientModel={handleOpenVarientModel}
            openCart={props.openCart}
            buttonOverride={props.buttonOverride}
            marketShowPrice={props.marketShowPrice}
            bhpEditLinks={props.businessDetails.bhpEditLinks}
            advanceCustomization={props.advanceCustomization}
          />
        </div>
      </a>
    </>
  );

  // if (props.orientation) {
  return (
    <>
      {!props.listModeListing && businessCardVerticalJsx}
      {!!props.listModeListing && businessCardHorizontalJsx}
      {variantModalJsx}
    </>
  );
  // } else {
  // return <>{businessCardHorizontalJsx}</>;
  // }
};

export default BussinessHomeCard;
